/**
 * BombPowerup
 * Handles logic for bomb powerup.
 */

export default class BombPowerup {
    // ==================== Construction ====================
    constructor(game, board) {
        window.bmb = this;
        this.game = game;
        this.board = board;

        this.view = PARAMS.makeSprite(game, 0, 0, 'gameElements', 'bombDisabled.png');
        this.anims = PARAMS.makeSprite(game, 0, 0, 'flashAnims2', 'bombButtonReadyAnimation/0000');

        var frames = window.Phaser.Animation.generateFrameNames('bombButtonReadyAnimation/', 0, 26, '', 4);
        this.anims.animations.add('activate', frames, 24, false);
        // this.anims.animations.add('disabled', ['BombPowerupDisabled.png'], 14, false)

        this.anims.events.onAnimationComplete.add(function () {
            this.anims.alpha = 0;
            if (GS.availableBombs === 0) {
                this.disable();
                this.view.frameName = 'bombDisabled.png'
            }
        }, this);
        this.view.addChild(this.anims);

        // enable input and add callbacks for events
        this.view.inputEnabled = true;
        this.view.input.disableDrag();

        this.view.events.onDragStart.add(this.dragStart, this);
        this.view.events.onDragUpdate.add(this.dragUpdate, this);
        this.view.events.onDragStop.add(this.dragStop, this);

        this.basePositionX = 40 * PARAMS.scaleFactor;
        this.basePositionY = 286 * PARAMS.scaleFactor;

        this.anims.alpha = 0;
        this.anims.x = -52 * PARAMS.scaleFactor;
        this.anims.y = -50 * PARAMS.scaleFactor;

        this.lastTile = null; // helper to remember which tile was selected for bomb as last one
        this.active = false;
    }

    // ==================== Dragging ====================
    dragStart() {
        GS.onBombDragged();
    }

    dragUpdate(sprite, pointer) {
        var pos = sprite.game.input.getLocalPosition(sprite.parent, pointer);
        if (sprite.hitArea) {
            sprite.x = pos.x - sprite.hitArea.width / 2;
            sprite.y = pos.y - sprite.hitArea.height / 2
        }
        else {
            sprite.x = pos.x - sprite.width / 2;
            sprite.y = pos.y - sprite.height / 2
        }

        var tile = this.board.boardInputController.getTileUnderPointer(pointer);
        // there is a tile, tile has changed since last selection and is not empty (invisible)
        if (tile && tile !== this.lastTile && tile.canBeSelected()) {
            // find all selected tiles
            this.board.boardInputController.clearSelected();
            this.board.boardInputController.selectAround(tile);
            this.board.boardInputController.onWordChangedFromPowerup();

            // update their view
            this.board.pathCreator.updateSelectedTilesForPowerup();

            this.lastTile = tile;
        } else if (!this.lastTile) {
            // didn't get over tile board yet

        } else if (!tile || (tile && !tile.canBeSelected())) {
            // bomb was moved outside tiles or over inactive(invisible) tile
            this.board.boardInputController.clearSelected();
            this.board.boardInputController.onWordChangedFromPowerup();
            this.lastTile = null;
        }
    }

    dragStop(pointer, sprite) {
        // if there are selected tiles and they were selected actually by bomb!
        if (this.board.boardInputController.selected.length > 0 && this.lastTile) {
            this.board.boardInputController.onWordConfirmedFromPowerup();
            GS.onBombDroppedWithUse()
        }
        else {
            GS.onBombDroppedWithoutUse()
        }

        this.view.x = this.basePositionX;
        this.view.y = this.basePositionY;
        this.lastTile = null
    }

    isDragged() {
        if (this.view.x !== this.basePositionX || this.view.y !== this.basePositionY) {
            return true;
        }
        return false;
    }

    setBasePosition(x, y) {
        this.basePositionX = this.view.x = x;
        this.basePositionY = this.view.y = y;
    }

    // ==================== Animations ====================
    playActivationAnim() {
        // AUDIO.playSound('bombCharged')
        this.anims.alpha = 1;
        this.anims.animations.play('activate');
    }

    playAnimationWithDisabling() {
        // AUDIO.playSound('bombCharged')
        this.view.input.disableDrag();
        this.anims.alpha = 1;
        this.anims.animations.play('activate');
    }

    // ==================== Activation ====================
    activate() {
        this.active = true;
        this.view.frameName = 'bomb.png';
        this.view.input.enableDrag();
        this.playActivationAnim();

        this.view.anchor.set(0);
        this.view.x = this.basePositionX;
        this.view.y = this.basePositionY;
    }

    disable() {
        this.active = false;

        this.view.input.disableDrag();
        this.anims.alpha = 0;
        this.view.frameName = 'bombDisabled.png';
        // this.view.animations.play('disabled')

        this.view.anchor.set(0);
        this.view.x = this.basePositionX;
        this.view.y = this.basePositionY;
    }

    // ==================== Events ====================
    onPause() {
        if (!this.active) {
            return;
        }
        this.view.input.disableDrag();
        this.board.boardInputController.onWordCleared();
        this.lastTile = null;

        if (this.isDragged()) {
            this.dragStop(null, null);
        }
    }

    onResume() {
        if (this.active) {
            this.view.input.enableDrag(true);
        }
    }
}
